export enum CartStatus {
  Pending = 'PENDING',
  Preflight = 'PREFLIGHT',
  Processing = 'PROCESSING',
  Sent = 'SENT',
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  PAYMENT_REQUESTED = 'PAYMENT_REQUESTED',
  PAID = 'PAID',
  PAID_PARTIALLY = 'PAID_PARTIALLY',
  PREFLIGHT = 'PREFLIGHT',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
  REFUNDED = 'REFUNDED',
  REFUNDED_PARTIALLY = 'REFUNDED_PARTIALLY',
  REFUND_FAILED = 'REFUND_FAILED',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',
  CANCELLATION_FAILED = 'CANCELLATION_FAILED',
  CANCELLED_PARTIALLY = 'CANCELLED_PARTIALLY',
  PARTIAL = 'PARTIAL',
}

export enum FulfillmentStatus {
  Paid = 'PAID',
  Created = 'CREATED',
  Pending = 'PENDING',
  Hold = 'HOLD',
  FraudHold = 'FRAUD_HOLD',
  Cancelled = 'CANCELLED',
  Sent = 'SENT',
}

export enum EarnStatus {
  EarnHold = 'EARN_HOLD',
  PendingEarn = 'PENDING_EARN',
  EarnRequested = 'EARN_REQUESTED',
  Earned = 'EARNED',
  PendingReversal = 'PENDING_REVERSAL',
  ReversalRequested = 'REVERSAL_REQUESTED',
  Reversed = 'REVERSED',
  ReversalRejected = 'REVERSAL_REJECTED',
  EarnRejected = 'EARN_REJECTED',
  ZeroCommission = 'ZERO_COMMISSION',
}

export enum PaymentOption {
  POINTS = 'points',
  CASH_AND_POINTS = 'cash+points',
  CASH = 'cash',
}

export enum ROSegmentCode {
  Status = 'status',
  NoStatus = 'non_status',
}

export enum SegmentLevel {
  Program = 'program',
  Segment = 'segment',
  SubSegment = 'subsegment',
}
